import { AnimatePresence, motion } from "motion/react";
import styled, { keyframes } from "styled-components";
import { AiOutlineLoading } from "react-icons/ai";

const spinner = keyframes`
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
`;

const Container = styled(motion.div)<{
    size: number;
    $showBackground: boolean;
    fullscreen: boolean;
}>`
    position: ${(props) => (props.fullscreen ? "fixed" : "absolute")};
    top: 0;
    left: 0;
    width: 100%;
    height: ${(props) => (props.fullscreen ? "100vh" : "100%")};
    background: ${(props) =>
        props.$showBackground ? "rgb(255, 255, 255, 1)" : "none"};
    backdrop-filter: ${(props) =>
        props.$showBackground ? "blur(5px) brightness(0.5)" : "none"};
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: inherit;

    .spinner {
        display: flex;
        animation: ${spinner} 0.5s linear infinite;
        transform: translateZ(0px);
        will-change: transform;

        svg {
            color: var(--dark-blue);
            width: ${(props) => `${props.size}rem`};
            height: ${(props) => `${props.size}rem`};
        }
    }
`;

type LoadingOptions = {
    showBackground?: boolean;
    size?: number;
    fullscreen?: boolean;
};

export const Loading = ({
    isLoading,
    options = { showBackground: true, size: 8 },
}: {
    isLoading: boolean;
    options?: LoadingOptions;
}) => {
    return (
        <AnimatePresence>
            {isLoading && (
                <Container
                    size={options.size || 8}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    $showBackground={options.showBackground || true}
                    fullscreen={options.fullscreen || false}
                >
                    <motion.div
                        className="spinner"
                        // animate={{ rotate: [0, 360] }}
                        // transition={{
                        //     ease: "linear",
                        //     repeat: Infinity,
                        //     duration: 0.5,
                        // }}
                    >
                        <AiOutlineLoading />
                    </motion.div>
                </Container>
            )}
        </AnimatePresence>
    );
};
